/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyEmail} from '../api'

export const useMutationVerifyEmail = createReactQueryMutationHook('verifyEmail', verifyEmail)
